import { Button, message, Popconfirm, Popover, TableColumnType, Col, Space, Tooltip } from 'antd'
import _, { sum } from 'lodash'
import moment from 'moment'
import React from 'react'
import { DateTimeFormatSimple, DateTimeFormatSimpleOnly } from '../../models/datetime'
import {
  BillName,
  Category,
  ctrlShowCol,
  getOutTitleName,
  getUnitTitleName,
} from '../../models/category'
import '../putstorelist/notshow.css'
import {
  AccountOutlined,
  DelectOutlined,
  ReverseOutlined,
} from '../../compnents/icons/Icons'
import { Dimen } from '../../models/dimen'
import { CloseOutlined, WarningOutlined } from '@ant-design/icons'
import { useHistory } from 'react-router-dom'
import { EditableColumnType } from '../../compnents/list/EditableList'
import { useSelector } from 'react-redux'
import { selectTenantCategory } from '../../app/applicationSlice'
import styles from './putstorage.module.css'
import { ItemCompletionType } from '../completion/completionSlice'
import listAccount from "../../compnents/icons/png/listAccount.png";

export const ColumnsAuthInclude = (
  onClick: (id: number, text: string) => void,
  startIndex: number,
  category: Category,
  YBUploadcategory?: string
): TableColumnType<any>[] => {

  const history = useHistory()

  const tenantCategory = useSelector(selectTenantCategory)

  const layout = {
    width: '14px',
    height: '18x',
    marginRight: '4px',
  }
  const columns: TableColumnType<any>[] = [
    {
      title: '序号',
      align: 'center',
      width: '50px',
      ellipsis: true,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '库房名称',
      align: 'center',
      dataIndex: 'storehouseName',
      width: '120px',
      ellipsis: true,
      key: 'storehouseName',
      sorter: (a, b) => a.storehouseName.localeCompare(b.storehouseName),
    },
    {
      title: '业务单号',
      align: 'center',
      width: '180px',
      ellipsis: true,
      dataIndex: 'putNumber',
      key: 'putNumber',
    },
    {
      title: '供应商',
      align: 'center',
      width: '200px',
      ellipsis: true,
      dataIndex: 'supplierName',
      key: 'supplierName',
      sorter: (a: any, b: any) => a.supplierName.length - b.supplierName.length,
      render: (_, t) => {
        return t.supplierName ? t.supplierName : t.acceptStorehouseName
      },
    },
    {
      title: '业务部门',
      align: 'center',
      dataIndex: 'departmentName',
      width: '110px',
      ellipsis: true,
      key: 'departmentName',
      sorter: (a, b) => a.departmentName.localeCompare(b.departmentName),
    },
    {
      title: '业务人员',
      align: 'center',
      dataIndex: 'userName',
      width: '110px',
      ellipsis: true,
      key: 'userName',
      sorter: (a, b) => a.userName.localeCompare(b.userName),
    },
    {
      title: '是否登账',
      align: 'center',
      width: '110px',
      ellipsis: true,
      dataIndex: 'storehouseTag',
      key: 'storehouseTag',
      sorter: (a: any, b: any) => a.storehouseTag - b.storehouseTag,
      render: (storehouseTag: number) => {
        switch (storehouseTag) {
          case 0:
            return '否'
          case 1:
            return <span style={{ color: '#1CD0BD' }}>是</span>
          case 2:
            return '已作废'
          case 3:
            return '已冲正'
          default:
            break
        }
      },
    },
    {
      title: '登账人员',
      align: 'center',
      dataIndex: 'upAccountUserName',
      width: '110px',
      ellipsis: true,
      key: 'upAccountUserName',
      render: (upAccountUserName) => {
        return upAccountUserName ? upAccountUserName : '-'
      },
    },
    {
      title: '是否验收',
      align: 'center',
      width: '110px',
      ellipsis: true,
      dataIndex: 'acceptanceStatus',
      key: 'acceptanceStatus',
      render: (acceptanceStatus: number) => {
        switch (acceptanceStatus) {
          case 0:
            return '未验收'
          case 1:
            return '已验收'
          default:
            break
        }
      },
    },
    {
      title: '验收人员',
      align: 'center',
      dataIndex: 'acceptanceUserName',
      width: '110px',
      ellipsis: true,
      key: 'acceptanceUserName',
      render: (acceptanceUserName) => {
        return acceptanceUserName ? acceptanceUserName : '-'
      },
    },
    {
      title: '业务日期',
      align: 'center',
      dataIndex: 'recepitsDate',
      width: '110px',
      ellipsis: true,
      key: 'recepitsDate',
      sorter: (a: any, b: any) =>
        moment(a.recepitsDate).unix() - moment(b.recepitsDate).unix(),
      render: (recepitsDate) => {
        return recepitsDate
          ? moment(recepitsDate).format(DateTimeFormatSimple)
          : ''
      },
    },
    {
      title: '创建时间',
      align: 'center',
      dataIndex: 'createTime',
      width: '110px',
      ellipsis: true,
      key: 'createTime',
      sorter: (a: any, b: any) =>
        moment(a.createTime).unix() - moment(b.createTime).unix(),
      render: (createTime) => {
        return createTime ? moment(createTime).format(DateTimeFormatSimple) : ''
      },
    },
    {
      title: '登账时间',
      align: 'center',
      width: '110px',
      ellipsis: true,
      sorter: (a: any, b: any) =>
        moment(a.upAccountTime || moment()).unix() -
        moment(b.upAccountTime || moment()).unix(),
      render: (_, t) => {
        switch (t.storehouseTag) {
          case 1:
          case 3:
            return moment(t.upAccountTime).format(DateTimeFormatSimple)
          default:
            return ''
        }
      },
    },
    {
      title: getUnitTitleName(category),
      align: 'right',
      dataIndex: 'shouldPayMoney',
      width: '100px',
      ellipsis: true,
      key: 'shouldPayMoney',
      render: (shouldPayMoney) => {
        return shouldPayMoney > -1 ? parseFloat(shouldPayMoney).toFixed(2) : 0
      },
    },
    {
      title: getOutTitleName(category),
      align: 'right',
      dataIndex: 'realPayMoney',
      width: '100px',
      ellipsis: true,
      className: ctrlShowCol(category) ? 'notshow' : '',
      key: 'realPayMoney',
      render: (realPayMoney) => {
        return realPayMoney > -1 ? parseFloat(realPayMoney).toFixed(2) : 0
      },
    },
    {
      title: '售价金额',
      align: 'right',
      dataIndex: 'totalRetailPrice',
      width: '100px',
      ellipsis: true,
      key: 'totalRetailPrice',
      render: (totalRetailPrice) => {
        return totalRetailPrice > -1
          ? parseFloat(totalRetailPrice).toFixed(2)
          : 0
      },
    },
    {
      title: '操作',
      fixed: 'right',
      align: 'center',
      width: '13rem',
      dataIndex: 'storehouseTag',
      key: 'storehouseTag',
      render: (storehouseTag, data) => {
        if (YBUploadcategory) {
          return data.ybUploadFlag === '2' ? (
            '已上传'
          ) : (
            <Popconfirm
              title='确认执行此操作？'
              onConfirm={() => {
                if (YBUploadcategory === '1') {
                  onClick(
                    data.id,
                    storehouseTag === 1 ? '采购单上传' : '冲正上传'
                  )
                } else if (YBUploadcategory === '2') {
                  onClick(
                    data.id,
                    storehouseTag === 1 ? '出库单上传' : '冲正上传'
                  )
                }
              }}
              okText='确认'
              cancelText='取消'
            >
              <Button type='primary' ghost size='small'>
                {storehouseTag === 1 ? '上传' : '冲正上传'}
              </Button>
            </Popconfirm>
          )
        } else {
          switch (storehouseTag) {
            case 0:
              return (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Tooltip title="登账后单据生效">
                    <Button
                      type='text'
                      size='small'
                      style={{
                        fontSize: '14px',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      icon={
                        <img src={listAccount} style={{ width: '14px', height: '14px', marginRight: '4px' }} />
                      }
                      onClick={(t: any) => {
                        onClick(data.id, '登账')
                      }}
                    >
                      登账
                    </Button>
                  </Tooltip>
                  <Button
                    type='text'
                    size='small'
                    style={{
                      fontSize: '14px',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                    icon={
                      <DelectOutlined style={{ fill: '#FF5D5D', ...layout }} />
                    }
                    onClick={(t: any) => {
                      onClick(data.id, '作废')
                    }}
                  >
                    作废
                  </Button>
                  <Button
                    type='text'
                    size='small'
                    style={{ color: '#027AFF', fontSize: '14px' }}
                    onClick={(t: any) => {
                      onClick(data.id, '查看详情')
                    }}
                  >
                    查看详情
                  </Button>
                </div>
              )
            case 1:
              return (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Tooltip title="冲正后单据失效，库存还原">
                    <Button
                      type='text'
                      size='small'
                      style={{
                        fontSize: '14px',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      icon={
                        <ReverseOutlined style={{ fill: '#F5BB4A', ...layout }} />
                      }
                      onClick={(t: any) => {
                        onClick(data.id, '冲正')
                      }}
                    >
                      冲正
                    </Button>
                  </Tooltip>
                  <Button
                    type='text'
                    size='small'
                    style={{ color: '#027AFF', fontSize: '14px' }}
                    onClick={(t: any) => {
                      onClick(data.id, '查看详情')
                    }}
                  >
                    查看详情
                  </Button>
                </div>
              )
            case 2:
            case 3:
              return (
                <div>
                  <Button
                    type='text'
                    size='small'
                    style={{ color: '#027AFF', fontSize: '14px' }}
                    onClick={(t: any) => {
                      onClick(data.id, '查看详情')
                    }}
                  >
                    查看详情
                  </Button>
                </div>
              )
            default:
              break
          }
        }
      },
    },
  ]

  return tenantCategory == 17 ? columns?.filter(v => v.key != 'totalRetailPrice') : columns
}

export const ColumnsAuth = (
  onClick: (id: number, text: string) => void,
  startIndex: number,
  category: Category,
  YBUploadcategory?: string
): TableColumnType<any>[] => {
  const layout = {
    width: '14px',
    height: '18x',
    marginRight: '4px',
  }
  return [
    {
      title: '序号',
      align: 'center',
      width: '50px',
      ellipsis: true,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '库房名称',
      align: 'center',
      dataIndex: 'storehouseName',
      width: '120px',
      ellipsis: true,
      key: 'storehouseName',
      sorter: (a, b) => a.storehouseName.localeCompare(b.storehouseName),
    },
    {
      title: '业务单号',
      align: 'center',
      width: '180px',
      ellipsis: true,
      dataIndex: 'putNumber',
      key: 'putNumber',
    },

    {
      title: '供应商',
      align: 'center',
      dataIndex: 'supplierName',
      key: 'supplierName',
      width: '200px',
      ellipsis: true,
      sorter: (a: any, b: any) => a.supplierName.length - b.supplierName.length,
      render: (_, t) => {
        return t.supplierName ? t.supplierName : t.acceptStorehouseName
      },
    },
    {
      title: '业务部门',
      align: 'center',
      dataIndex: 'departmentName',
      width: '110px',
      ellipsis: true,
      key: 'departmentName',
      sorter: (a, b) => a.departmentName.localeCompare(b.departmentName),
    },
    {
      title: '业务人员',
      align: 'center',
      dataIndex: 'userName',
      width: '110px',
      ellipsis: true,
      key: 'userName',
      sorter: (a, b) => a.userName.localeCompare(b.userName),
    },
    {
      title: '是否登账',
      align: 'center',
      width: '110px',
      ellipsis: true,
      dataIndex: 'storehouseTag',
      key: 'storehouseTag',
      sorter: (a: any, b: any) => a.storehouseTag - b.storehouseTag,
      render: (storehouseTag: number) => {
        switch (storehouseTag) {
          case 0:
            return '否'
          case 1:
            return <span style={{ color: '#1CD0BD' }}>是</span>
          case 2:
            return '已作废'
          case 3:
            return '已冲正'
          default:
            break
        }
      },
    },
    {
      title: '业务日期',
      align: 'center',
      dataIndex: 'recepitsDate',
      width: '110px',
      ellipsis: true,
      key: 'recepitsDate',
      sorter: (a: any, b: any) =>
        moment(a.recepitsDate).unix() - moment(b.recepitsDate).unix(),
      render: (recepitsDate) => {
        return recepitsDate
          ? moment(recepitsDate).format(DateTimeFormatSimple)
          : ''
      },
    },
    {
      title: '创建时间',
      align: 'center',
      dataIndex: 'createTime',
      width: '110px',
      ellipsis: true,
      key: 'createTime',
      sorter: (a: any, b: any) =>
        moment(a.createTime).unix() - moment(b.createTime).unix(),
      render: (createTime) => {
        return createTime ? moment(createTime).format(DateTimeFormatSimple) : ''
      },
    },
    {
      title: '登账时间',
      align: 'center',
      width: '110px',
      ellipsis: true,
      sorter: (a: any, b: any) =>
        moment(a.upAccountTime || moment()).unix() -
        moment(b.upAccountTime || moment()).unix(),
      render: (_, t) => {
        switch (t.storehouseTag) {
          case 1:
          case 3:
            return moment(t.upAccountTime).format(DateTimeFormatSimple)
          default:
            return ''
        }
      },
    },
    {
      title: getUnitTitleName(category),
      align: 'right',
      dataIndex: 'shouldPayMoney',
      width: '100px',
      ellipsis: true,
      key: 'shouldPayMoney',
      render: (shouldPayMoney) => {
        return shouldPayMoney > -1 ? parseFloat(shouldPayMoney).toFixed(2) : 0
      },
    },
    {
      title: getOutTitleName(category),
      align: 'right',
      dataIndex: 'realPayMoney',
      width: '100px',
      ellipsis: true,
      className: ctrlShowCol(category) ? 'notshow' : '',
      key: 'realPayMoney',
      render: (realPayMoney) => {
        return realPayMoney > -1 ? parseFloat(realPayMoney).toFixed(2) : 0
      },
    },
    {
      title: '操作',
      fixed: 'right',
      align: 'center',
      ellipsis: true,
      width: '13rem',
      dataIndex: 'storehouseTag',
      key: 'storehouseTag',
      render: (storehouseTag, data) => {
        if (YBUploadcategory) {
          return data.ybUploadFlag === '2' ? (
            '已上传'
          ) : (
            <Popconfirm
              title='确认执行此操作？'
              onConfirm={() => {
                if (YBUploadcategory === '1') {
                  onClick(
                    data.id,
                    storehouseTag === 1 ? '采购单上传' : '冲正上传'
                  )
                } else if (YBUploadcategory === '2') {
                  onClick(
                    data.id,
                    storehouseTag === 1 ? '出库单上传' : '冲正上传'
                  )
                }
              }}
              okText='确认'
              cancelText='取消'
            >
              <Button type='primary' ghost size='small'>
                {storehouseTag === 1 ? '上传' : '冲正上传'}
              </Button>
            </Popconfirm>
          )
        } else {
          switch (storehouseTag) {
            case 0:
              return (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Tooltip title="登账后单据生效">
                    <Button
                      type='text'
                      size='small'
                      style={{
                        fontSize: '14px',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      icon={
                        <img src={listAccount} style={{ width: '14px', height: '14px', marginRight: '4px' }} />
                      }
                      onClick={(t: any) => {
                        onClick(data.id, '登账')
                      }}
                    >
                      登账
                    </Button>
                  </Tooltip>
                  <Button
                    type='text'
                    size='small'
                    style={{
                      fontSize: '14px',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                    icon={
                      <DelectOutlined style={{ fill: '#FF5D5D', ...layout }} />
                    }
                    onClick={(t: any) => {
                      onClick(data.id, '作废')
                    }}
                  >
                    作废
                  </Button>
                  <Button
                    type='text'
                    size='small'
                    style={{ color: '#027AFF', fontSize: '14px' }}
                    onClick={(t: any) => {
                      onClick(data.id, '查看详情')
                    }}
                  >
                    查看详情
                  </Button>
                </div>
              )
            case 1:
              return (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Tooltip title="冲正后单据失效，库存还原">
                    <Button
                      type='text'
                      size='small'
                      style={{
                        fontSize: '14px',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      icon={
                        <ReverseOutlined style={{ fill: '#F5BB4A', ...layout }} />
                      }
                      onClick={(t: any) => {
                        onClick(data.id, '冲正')
                      }}
                    >
                      冲正
                    </Button>
                  </Tooltip>
                  <Button
                    type='text'
                    size='small'
                    style={{ color: '#027AFF', fontSize: '14px' }}
                    onClick={(t: any) => {
                      onClick(data.id, '查看详情')
                    }}
                  >
                    查看详情
                  </Button>
                </div>
              )
            case 2:
            case 3:
              return (
                <div>
                  <Button
                    type='text'
                    size='small'
                    style={{ color: '#027AFF', fontSize: '14px' }}
                    onClick={(t: any) => {
                      onClick(data.id, '查看详情')
                    }}
                  >
                    查看详情
                  </Button>
                </div>
              )
            default:
              break
          }
        }
      },
    },
  ]
}
export const PrintColumnsAuth = (
  startIndex: number,
  category: Category
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => {
        if (_2.id === 0) {
          return '合计'
        } else {
          return `${startIndex + index + 1}`
        }
      },
    },
    {
      title: '库房名称',
      align: 'center',
      width: Dimen.Name,
      dataIndex: 'storehouseName',
      key: 'storehouseName',
    },
    {
      title: '业务单号',
      align: 'center',
      width: Dimen.PutNumber,
      dataIndex: 'putNumber',
      key: 'putNumber',
    },
    {
      title: '业务部门',
      align: 'center',
      width: Dimen.Department,
      dataIndex: 'departmentName',
      key: 'departmentName',
    },
    {
      title: '业务人员',
      align: 'center',
      width: Dimen.Name,
      dataIndex: 'userName',
      key: 'userName',
    },
    {
      title: '创建时间',
      align: 'center',
      width: Dimen.Time,
      dataIndex: 'createTime',
      key: 'createTime',
      render: (createTime) => {
        return createTime ? moment(createTime).format(DateTimeFormatSimple) : ''
      },
    },
    {
      title: '登账时间',
      align: 'center',
      width: Dimen.Time,
      render: (_, t) => {
        switch (t.storehouseTag) {
          case 1:
            return moment(t.upAccountTime).format(DateTimeFormatSimple)
          default:
            return ''
        }
      },
    },
    {
      title: getUnitTitleName(category),
      align: 'right',
      width: Dimen.Price,
      dataIndex: 'shouldPayMoney',
      key: 'shouldPayMoney',
      render: (shouldPayMoney) => {
        return shouldPayMoney > -1 ? parseFloat(shouldPayMoney).toFixed(2) : 0
      },
    },
    {
      title: getOutTitleName(category),
      align: 'right',
      width: Dimen.Price,
      dataIndex: 'realPayMoney',
      className: ctrlShowCol(category) ? 'notshow' : '',
      key: 'realPayMoney',
      render: (realPayMoney) => {
        return realPayMoney > -1 ? parseFloat(realPayMoney).toFixed(2) : 0
      },
    },
  ]
}

export const PrintColumnsGRTK = (
  startIndex: number,
  category: Category
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      align: 'center',
      width: '4rem',
      render: (_1, _2, index) => {
        if (_2.id === 0) {
          return '合计'
        } else {
          return `${startIndex + index + 1}`
        }
      },
    },
    {
      title: '库房名称',
      align: 'center',
      // width:'6rem',
      dataIndex: 'storehouseName',
      key: 'storehouseName',
    },
    {
      title: '业务单号',
      align: 'center',
      // width: Dimen.PutNumber,
      dataIndex: 'putNumber',
      key: 'putNumber',
    },
    {
      title: '供应商',
      align: 'center',
      dataIndex: 'supplierName',
      key: 'supplierName',
      // width: '6rem',
      render: (_, t) => {
        return t.supplierName ? t.supplierName : t.acceptStorehouseName
      },
    },
    {
      title: '业务部门',
      align: 'center',
      // width: Dimen.Department,
      dataIndex: 'departmentName',
      key: 'departmentName',
    },
    {
      title: '业务人员',
      align: 'center',
      // width: Dimen.Name,
      dataIndex: 'userName',
      key: 'userName',
    },
    {
      title: '创建时间',
      align: 'center',
      // width: Dimen.Time,
      dataIndex: 'createTime',
      key: 'createTime',
      render: (createTime) => {
        return createTime ? moment(createTime).format(DateTimeFormatSimple) : ''
      },
    },
    {
      title: '登账时间',
      align: 'center',
      // width: Dimen.Time,
      render: (_, t) => {
        switch (t.storehouseTag) {
          case 1:
            return moment(t.upAccountTime).format(DateTimeFormatSimple)
          default:
            return ''
        }
      },
    },
    {
      title: getUnitTitleName(category),
      align: 'right',
      // width: Dimen.Price,
      dataIndex: 'shouldPayMoney',
      key: 'shouldPayMoney',
      render: (shouldPayMoney) => {
        return shouldPayMoney > -1 ? parseFloat(shouldPayMoney).toFixed(2) : 0
      },
    },
    {
      title: getOutTitleName(category),
      align: 'right',
      // width: Dimen.Price,
      dataIndex: 'realPayMoney',
      className: ctrlShowCol(category) ? 'notshow' : '',
      key: 'realPayMoney',
      render: (realPayMoney) => {
        return realPayMoney > -1 ? parseFloat(realPayMoney).toFixed(2) : 0
      },
    },
  ]
}

export const TBCKColumnsAuthOut = (
  onClick: (id: number, text: string) => void,
  startIndex: number,
  category: Category
): TableColumnType<any>[] => {
  const layout = {
    width: '14px',
    height: '14x',
    marginRight: '4px',
  }
  const columns: TableColumnType<any>[] = [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '接收库房',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      dataIndex: 'acceptStorehouseName',
      key: 'acceptStorehouseName',
      sorter: (a: any, b: any) =>
        a.acceptStorehouseName?.length - b.acceptStorehouseName?.length,
    },
    {
      title: '调出库房',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      dataIndex: 'storehouseName',
      key: 'storehouseName',
      sorter: (a: any, b: any) =>
        a.storehouseName.length - b.storehouseName.length,
    },
    {
      title: '业务单号',
      align: 'center',
      dataIndex: 'putNumber',
      width: '12rem',
      ellipsis: true,
      key: 'putNumber',
    },
    {
      title: '业务部门',
      align: 'center',
      dataIndex: 'departmentName',
      key: 'departmentName',
      width: '8rem',
      ellipsis: true,
      sorter: (a: any, b: any) =>
        a.departmentName.length - b.departmentName.length,
    },
    {
      title: '业务人员',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      dataIndex: 'userName',
      key: 'userName',
      sorter: (a: any, b: any) => a.userName.length - b.userName.length,
    },
    {
      title: '是否登账',
      align: 'center',
      dataIndex: 'storehouseTag',
      key: 'storehouseTag',
      width: '8rem',
      ellipsis: true,
      sorter: (a: any, b: any) => a.storehouseTag - b.storehouseTag,
      render: (storehouseTag: number) => {
        switch (storehouseTag) {
          case 0:
            return '否'
          case 1:
            return <span style={{ color: '#1CD0BD' }}>是</span>
          case 2:
            return '已作废'
          case 3:
            return '已冲正'
          default:
            break
        }
      },
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      key: 'createTime',
      sorter: (a: any, b: any) =>
        moment(a.createTime).unix() - moment(b.createTime).unix(),
      render: (createTime) => {
        return createTime ? moment(createTime).format(DateTimeFormatSimple) : ''
      },
    },
    {
      title: '登账时间',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      sorter: (a: any, b: any) =>
        moment(a.upAccountTime).unix() - moment(b.upAccountTime).unix(),
      render: (_, t) => {
        switch (t.storehouseTag) {
          case 1:
            return moment(t.upAccountTime).format(DateTimeFormatSimple)
          default:
            return ''
        }
      },
    },
    {
      title: getUnitTitleName(category),
      align: 'right',
      width: '10rem',
      ellipsis: true,
      dataIndex: 'totalUnitPrice',
      key: 'totalUnitPrice',
      render: (totalUnitPrice) => {
        return totalUnitPrice > -1 ? parseFloat(totalUnitPrice).toFixed(2) : 0
      },
    },
    {
      title: getOutTitleName(category),
      align: 'right',
      width: '10rem',
      ellipsis: true,
      dataIndex: 'totalRetailPrice',
      className: ctrlShowCol(category) ? 'notshow' : '',
      key: 'totalRetailPrice',
      render: (totalRetailPrice) => {
        return totalRetailPrice > -1
          ? parseFloat(totalRetailPrice).toFixed(2)
          : 0
      },
    },
    {
      width: '13rem',
      title: '操作',
      fixed: 'right',
      align: 'center',
      dataIndex: 'storehouseTag',
      key: 'storehouseTag',
      render: (storehouseTag, data) => {
        switch (storehouseTag) {
          case 0:
            return (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Tooltip title="登账后单据生效">
                  <Button
                    type='text'
                    size='small'
                    style={{
                      fontSize: '14px',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                    icon={
                      <img src={listAccount} style={{ width: '14px', height: '14px', marginRight: '4px' }} />
                    }
                    onClick={(t: any) => {
                      onClick(data.id, '登账')
                    }}
                  >
                    登账
                  </Button>
                </Tooltip>
                <Button
                  type='text'
                  size='small'
                  style={{
                    fontSize: '14px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                  icon={
                    <DelectOutlined style={{ fill: '#FF5D5D', ...layout }} />
                  }
                  onClick={(t: any) => {
                    onClick(data.id, '作废')
                  }}
                >
                  作废
                </Button>
                <Button
                  type='text'
                  size='small'
                  style={{ color: '#027AFF', fontSize: '14px' }}
                  onClick={(t: any) => {
                    onClick(data.id, '查看详情')
                  }}
                >
                  查看详情
                </Button>
              </div>
            )
          case 1:
            return (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Tooltip title="冲正后单据失效，库存还原">
                  <Button
                    type='text'
                    size='small'
                    style={{
                      fontSize: '14px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                    icon={
                      <ReverseOutlined style={{ fill: '#F5BB4A', ...layout }} />
                    }
                    onClick={(t: any) => {
                      onClick(data.id, '冲正')
                    }}
                  >
                    冲正
                  </Button>
                </Tooltip>
                <Button
                  type='text'
                  size='small'
                  style={{
                    color: '#027AFF',
                    fontSize: '14px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                  onClick={(t: any) => {
                    onClick(data.id, '查看详情')
                  }}
                >
                  查看详情
                </Button>
              </div>
            )
          case 2:
          case 3:
            return (
              <div>
                <Button
                  type='text'
                  size='small'
                  style={{ color: '#027AFF', fontSize: '14px' }}
                  onClick={(t: any) => {
                    onClick(data.id, '查看详情')
                  }}
                >
                  查看详情
                </Button>
              </div>
            )
          default:
            break
        }
      },
    },
  ]
  return ctrlShowCol(category)
    ? columns?.filter((v: any) => v.key != 'totalRetailPrice')
    : columns
}

export const ColumnsAuthOut = (
  onClick: (id: number, text: string) => void,
  startIndex: number,
  category: Category
): TableColumnType<any>[] => {
  const tenantCategory = useSelector(selectTenantCategory)
  const layout = {
    width: '14px',
    height: '14x',
    marginRight: '4px',
  }
  const columns: TableColumnType<any>[] = [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '库房名称',
      align: 'center',
      width: Dimen.Name,
      ellipsis: true,
      dataIndex: 'storehouseName',
      key: 'storehouseName',
      sorter: (a: any, b: any) =>
        a.storehouseName.length - b.storehouseName.length,
    },
    {
      title: '业务单号',
      align: 'center',
      dataIndex: 'putNumber',
      width: '12rem',
      ellipsis: true,
      key: 'putNumber',
    },
    {
      title: '业务部门',
      align: 'center',
      dataIndex: 'departmentName',
      key: 'departmentName',
      width: Dimen.Department,
      ellipsis: true,
      sorter: (a: any, b: any) =>
        a.departmentName.length - b.departmentName.length,
    },
    {
      title: '业务人员',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      dataIndex: 'userName',
      key: 'userName',
      sorter: (a: any, b: any) => a.userName.length - b.userName.length,
    },
    {
      title: '是否登账',
      align: 'center',
      dataIndex: 'storehouseTag',
      key: 'storehouseTag',
      width: Dimen.State,
      ellipsis: true,
      sorter: (a: any, b: any) => a.storehouseTag - b.storehouseTag,
      render: (storehouseTag: number) => {
        switch (storehouseTag) {
          case 0:
            return '否'
          case 1:
            return <span style={{ color: '#1CD0BD' }}>是</span>
          case 2:
            return '已作废'
          case 3:
            return '已冲正'
          default:
            break
        }
      },
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      align: 'center',
      width: Dimen.Time,
      ellipsis: true,
      key: 'createTime',
      sorter: (a: any, b: any) =>
        moment(a.createTime).unix() - moment(b.createTime).unix(),
      render: (createTime) => {
        return createTime ? moment(createTime).format(DateTimeFormatSimple) : ''
      },
    },
    {
      title: '登账时间',
      align: 'center',
      width: Dimen.Time,
      ellipsis: true,
      sorter: (a: any, b: any) =>
        moment(a.upAccountTime).unix() - moment(b.upAccountTime).unix(),
      render: (_, t) => {
        switch (t.storehouseTag) {
          case 1:
            return moment(t.upAccountTime).format(DateTimeFormatSimple)
          default:
            return ''
        }
      },
    },
    {
      title: getUnitTitleName(category),
      align: 'right',
      width: Dimen.Price,
      ellipsis: true,
      dataIndex: 'totalUnitPrice',
      key: 'totalUnitPrice',
      render: (totalUnitPrice) => {
        return totalUnitPrice > -1 ? parseFloat(totalUnitPrice).toFixed(2) : 0
      },
    },
    {
      title: getOutTitleName(category),
      align: 'right',
      width: Dimen.Price,
      ellipsis: true,
      dataIndex: 'totalRetailPrice',
      className: ctrlShowCol(category) ? 'notshow' : '',
      key: 'totalRetailPrice',
      render: (totalRetailPrice) => {
        return totalRetailPrice > -1
          ? parseFloat(totalRetailPrice).toFixed(2)
          : 0
      },
    },
    {
      title: '操作',
      fixed: 'right',
      align: 'center',
      width: '16rem',
      dataIndex: 'storehouseTag',
      key: 'storehouseTag',
      render: (storehouseTag, data) => {
        switch (storehouseTag) {
          case 0:
            return (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Tooltip title="登账后单据生效">
                  <Button
                    type='text'
                    size='small'
                    style={{
                      fontSize: '14px',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                    icon={
                      <img src={listAccount} style={{ width: '14px', height: '14px', marginRight: '4px' }} />
                    }
                    onClick={(t: any) => {
                      onClick(data.id, '登账')
                    }}
                  >
                    登账
                  </Button>
                </Tooltip>
                <Button
                  type='text'
                  size='small'
                  style={{
                    fontSize: '14px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                  icon={
                    <DelectOutlined style={{ fill: '#FF5D5D', ...layout }} />
                  }
                  onClick={(t: any) => {
                    onClick(data.id, '作废')
                  }}
                >
                  作废
                </Button>
                <Button
                  type='text'
                  size='small'
                  style={{ color: '#027AFF', fontSize: '14px' }}
                  onClick={(t: any) => {
                    onClick(data.id, '查看详情')
                  }}
                >
                  查看详情
                </Button>
              </div>
            )
          case 1:
            return (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Tooltip title="冲正后单据失效，库存还原">
                  <Button
                    type='text'
                    size='small'
                    style={{
                      fontSize: '14px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                    icon={
                      <ReverseOutlined style={{ fill: '#F5BB4A', ...layout }} />
                    }
                    onClick={(t: any) => {
                      onClick(data.id, '冲正')
                    }}
                  >
                    冲正
                  </Button>
                </Tooltip>
                <Button
                  type='text'
                  size='small'
                  style={{
                    color: '#027AFF',
                    fontSize: '14px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                  onClick={(t: any) => {
                    onClick(data.id, '查看详情')
                  }}
                >
                  查看详情
                </Button>
              </div>
            )
          case 2:
          case 3:
            return (
              <div>
                <Button
                  type='text'
                  size='small'
                  style={{ color: '#027AFF', fontSize: '14px' }}
                  onClick={(t: any) => {
                    onClick(data.id, '查看详情')
                  }}
                >
                  查看详情
                </Button>
              </div>
            )
          default:
            break
        }
      },
    },
  ]
  return ctrlShowCol(category)
    ? columns?.filter((v: any) => v.key != 'totalRetailPrice')
    : category == '7' && tenantCategory == 17 ? columns?.filter((v: any) => v.key != 'totalRetailPrice') : columns
}

// 调拨出库打印
export const PrintTBCKColumnsAuthOut = (
  startIndex: number,
  category: Category
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => {
        if (_2.id === 0) {
          return '合计'
        } else {
          return `${startIndex + index + 1}`
        }
      },
    },
    {
      title: '接收库房',
      align: 'center',
      width: Dimen.Name,
      dataIndex: 'acceptStorehouseName',
      key: 'acceptStorehouseName',
      sorter: (a: any, b: any) =>
        a.acceptStorehouseName?.length - b.acceptStorehouseName?.length,
    },
    {
      title: '调出库房',
      align: 'center',
      width: Dimen.Name,
      dataIndex: 'storehouseName',
      key: 'storehouseName',
      sorter: (a: any, b: any) =>
        a.storehouseName.length - b.storehouseName.length,
    },
    {
      title: '业务单号',
      align: 'center',
      width: Dimen.PutNumber,
      dataIndex: 'putNumber',
      key: 'putNumber',
    },
    {
      title: '业务部门',
      align: 'center',
      width: Dimen.Department,
      dataIndex: 'departmentName',
      key: 'departmentName',
    },
    {
      title: '业务人员',
      align: 'center',
      width: Dimen.Name,
      dataIndex: 'userName',
      key: 'userName',
    },
    {
      title: '创建时间',
      align: 'center',
      width: Dimen.Time,
      dataIndex: 'createTime',
      key: 'createTime',
      render: (createTime) => {
        return createTime ? moment(createTime).format(DateTimeFormatSimple) : ''
      },
    },
    {
      title: '登账时间',
      align: 'center',
      width: Dimen.Time,
      render: (_, t) => {
        switch (t.storehouseTag) {
          case 1:
            return moment(t.upAccountTime).format(DateTimeFormatSimple)
          default:
            return ''
        }
      },
    },
    {
      title: getUnitTitleName(category),
      align: 'right',
      width: Dimen.Price,
      dataIndex: 'totalUnitPrice',
      key: 'totalUnitPrice',
      render: (totalUnitPrice) => {
        return totalUnitPrice > -1 ? parseFloat(totalUnitPrice).toFixed(2) : 0
      },
    },
    {
      title: getOutTitleName(category),
      align: 'right',
      width: Dimen.Price,
      dataIndex: 'totalRetailPrice',
      className: ctrlShowCol(category) ? 'notshow' : '',
      key: 'totalRetailPrice',
      render: (totalRetailPrice) => {
        return totalRetailPrice > -1
          ? parseFloat(totalRetailPrice).toFixed(2)
          : 0
      },
    },
  ]
}

export const PrintColumnsAuthOut = (
  startIndex: number,
  category: Category
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => {
        if (_2.id === 0) {
          return '合计'
        } else {
          return `${startIndex + index + 1}`
        }
      },
    },
    {
      title: '库房名称',
      align: 'center',
      width: Dimen.Name,
      dataIndex: 'storehouseName',
      key: 'storehouseName',
    },
    {
      title: '业务单号',
      align: 'center',
      width: Dimen.PutNumber,
      dataIndex: 'putNumber',
      key: 'putNumber',
    },
    {
      title: '业务部门',
      align: 'center',
      width: Dimen.Department,
      dataIndex: 'departmentName',
      key: 'departmentName',
    },
    {
      title: '业务人员',
      align: 'center',
      width: Dimen.Name,
      dataIndex: 'userName',
      key: 'userName',
    },
    {
      title: '创建时间',
      align: 'center',
      width: Dimen.Time,
      dataIndex: 'createTime',
      key: 'createTime',
      render: (createTime) => {
        return createTime ? moment(createTime).format(DateTimeFormatSimple) : ''
      },
    },
    {
      title: '登账时间',
      align: 'center',
      width: Dimen.Time,
      render: (_, t) => {
        switch (t.storehouseTag) {
          case 1:
            return moment(t.upAccountTime).format(DateTimeFormatSimple)
          default:
            return ''
        }
      },
    },
    {
      title: getUnitTitleName(category),
      align: 'right',
      width: Dimen.Price,
      dataIndex: 'totalUnitPrice',
      key: 'totalUnitPrice',
      render: (totalUnitPrice) => {
        return totalUnitPrice > -1 ? parseFloat(totalUnitPrice).toFixed(2) : 0
      },
    },
    {
      title: getOutTitleName(category),
      align: 'right',
      width: Dimen.Price,
      dataIndex: 'totalRetailPrice',
      className: ctrlShowCol(category) ? 'notshow' : '',
      key: 'totalRetailPrice',
      render: (totalRetailPrice) => {
        return totalRetailPrice > -1
          ? parseFloat(totalRetailPrice).toFixed(2)
          : 0
      },
    },
  ]
}

export const ColumnsTransferIn = (
  onClick: (id: number, text: string, data?: any) => void,
  startIndex: number,
  YBUploadcategory?: string
): TableColumnType<any>[] => {
  const layout = {
    width: '14px',
    height: '14x',
    marginRight: '4px',
  }
  let c = []
  const colums: TableColumnType<any>[] = [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '接收库房',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      dataIndex: 'storehouseName',
      key: 'storehouseName',
      sorter: (a: any, b: any) =>
        a.storehouseName.length - b.storehouseName.length,
    },
    {
      title: '入库业务单号',
      align: 'center',
      width: '12rem',
      ellipsis: true,
      dataIndex: 'putNumber',
      key: 'putNumber',
    },
    {
      title: '出库业务单号',
      align: 'center',
      width: '12rem',
      ellipsis: true,
      dataIndex: 'acceptPutNumber',
      key: 'acceptPutNumber',
    },
    {
      title: '调出库房',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      dataIndex: 'supplierName',
      key: 'supplierName',
      sorter: (a: any, b: any) => a.supplierName.length - b.supplierName.length,
      render: (_, t) => {
        return t.supplierName ? t.supplierName : t.acceptStorehouseName
      },
    },
    {
      title: '业务部门',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      dataIndex: 'departmentName',
      key: 'departmentName',
      sorter: (a: any, b: any) =>
        a.departmentName.length - b.departmentName.length,
    },
    {
      title: '业务人员',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      dataIndex: 'userName',
      key: 'userName',
      sorter: (a: any, b: any) => a.userName.length - b.userName.length,
    },
    {
      title: '是否登账',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      dataIndex: 'storehouseTag',
      key: 'storehouseTag',
      sorter: (a: any, b: any) => a.storehouseTag - b.storehouseTag,
      render: (storehouseTag: number) => {
        switch (storehouseTag) {
          case 0:
            return '否'
          case 1:
            return <span style={{ color: '#1CD0BD' }}>是</span>
          case 2:
            return '已作废'
          case 3:
            return '已冲正'
          default:
            break
        }
      },
    },
    {
      title: '创建时间',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      dataIndex: 'createTime',
      key: 'createTime',
      sorter: (a: any, b: any) =>
        moment(a.createTime).unix() - moment(b.createTime).unix(),
      render: (createTime) => {
        return createTime ? moment(createTime).format(DateTimeFormatSimple) : ''
      },
    },
    {
      title: '登账时间',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      sorter: (a: any, b: any) =>
        moment(a.storehouseTag === 1 ? a.upAccountTime : null).unix() -
        moment(a.storehouseTag === 1 ? b.upAccountTime : null).unix(),
      render: (_, t) => {
        switch (t.storehouseTag) {
          case 1:
          case 3:
            return moment(t.upAccountTime).format(DateTimeFormatSimple)
          default:
            return ''
        }
      },
    },
    {
      title: '总金额（进价）',
      align: 'right',
      width: '9rem',
      ellipsis: true,
      dataIndex: 'totalUnitPrice',
      key: 'totalUnitPrice',
      render: (totalUnitPrice) => {
        return totalUnitPrice > -1 ? parseFloat(totalUnitPrice).toFixed(2) : 0
      },
    },
    {
      title: '总金额（售价）',
      align: 'right',
      width: '9rem',
      ellipsis: true,
      dataIndex: 'totalRetailPrice',
      key: 'totalRetailPrice',
      render: (totalRetailPrice) => {
        return totalRetailPrice > -1
          ? parseFloat(totalRetailPrice).toFixed(2)
          : 0
      },
    },
    {
      title: '操作类型',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      dataIndex: 'category',
      key: 'category',
      render: (_, t) => {
        return BillName(_)
      },
    },
    {
      title: '操作',
      fixed: 'right',
      align: 'center',
      dataIndex: 'storehouseTag',
      key: 'storehouseTag',
      width: '15rem',
      render: (storehouseTag, data) => {
        if (YBUploadcategory) {
          return (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {data.ybUploadFlag === '2' ? (
                '已上传'
              ) : (
                <Popconfirm
                  title='确认执行此操作？'
                  onConfirm={() => {
                    onClick(
                      data.id,
                      storehouseTag === 1 ? '其他上传' : '冲正上传',
                      data
                    )
                  }}
                  okText='确认'
                  cancelText='取消'
                >
                  <Button type='primary' ghost size='small'>
                    {storehouseTag === 1 ? '上传' : '冲正上传'}
                  </Button>
                </Popconfirm>
              )}
              {data.category != '1' ? (
                <></>
              ) : data?.traceCodeCount > 0 ? (
                <span
                  style={{
                    cursor: 'pointer',
                    color: '#17ab4a',
                    marginLeft: '20px',
                  }}
                  onClick={(() => {
                    onClick(data.id, '追溯码', data)
                  })}
                >
                  已扫描
                </span>
              ) : (
                <span
                  style={{
                    cursor: 'pointer',
                    color: '#e47a1f',
                    marginLeft: '20px',
                  }}
                  onClick={(() => {
                    onClick(data.id, '追溯码', data)
                  })}
                >
                  尚未扫描追溯码
                  <WarningOutlined
                    style={{
                      color: '#e47a1f',
                      marginLeft: '2px',
                      marginTop: '4px',
                    }}
                  />
                </span>
              )}
            </div>
          )
        } else {
          switch (storehouseTag) {
            case 0:
              return (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Tooltip title="登账后单据生效">
                    <Button
                      type='text'
                      size='small'
                      style={{
                        fontSize: '14px',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      icon={
                        <img src={listAccount} style={{ width: '14px', height: '14px', marginRight: '4px' }} />
                      }
                      onClick={(t: any) => {
                        onClick(data.id, '登账')
                      }}
                    >
                      登账
                    </Button>
                  </Tooltip>
                  <Button
                    type='text'
                    size='small'
                    style={{
                      fontSize: '14px',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                    icon={
                      <DelectOutlined style={{ fill: '#FF5D5D', ...layout }} />
                    }
                    onClick={(t: any) => {
                      onClick(data.id, '作废')
                    }}
                  >
                    作废
                  </Button>
                  <Button
                    type='text'
                    size='small'
                    style={{ fill: '#027AFF', fontSize: '14px' }}
                    onClick={(t: any) => {
                      onClick(data.id, '查看详情')
                    }}
                  >
                    查看详情
                  </Button>
                </div>
              )
            case 1:
              return (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Tooltip title="冲正后单据失效，库存还原">
                    <Button
                      type='text'
                      size='small'
                      style={{
                        fontSize: '14px',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      icon={
                        <ReverseOutlined style={{ fill: '#F5BB4A', ...layout }} />
                      }
                      onClick={(t: any) => {
                        onClick(data.id, '冲正')
                      }}
                    >
                      冲正
                    </Button>
                  </Tooltip>
                  <Button
                    type='text'
                    size='small'
                    style={{ color: '#027AFF', fontSize: '14px' }}
                    onClick={(t: any) => {
                      onClick(data.id, '查看详情')
                    }}
                  >
                    查看详情
                  </Button>
                </div>
              )
            case 2:
            case 3:
              return (
                <div>
                  <Button
                    type='text'
                    size='small'
                    style={{ color: '#027AFF', fontSize: '14px' }}
                    onClick={(t: any) => {
                      onClick(data.id, '查看详情')
                    }}
                  >
                    查看详情
                  </Button>
                </div>
              )
            default:
              break
          }
        }
      },
    },
  ]
  c = !YBUploadcategory ? colums.filter((v) => v.title != '操作类型') : colums
  return c
}

export const PrintColumnsTransferIn = (
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => {
        if (_2.id === 0) {
          return '合计'
        } else {
          return `${startIndex + index + 1}`
        }
      },
    },
    {
      title: '接收库房',
      align: 'center',
      width: Dimen.Name,
      dataIndex: 'storehouseName',
      key: 'storehouseName',
      sorter: (a: any, b: any) =>
        a.storehouseName.length - b.storehouseName.length,
    },
    {
      title: '入库业务单号',
      align: 'center',
      width: Dimen.PutNumber,
      dataIndex: 'putNumber',
      key: 'putNumber',
    },
    {
      title: '出库业务单号',
      align: 'center',
      width: Dimen.PutNumber,
      dataIndex: 'acceptPutNumber',
      key: 'acceptPutNumber',
    },
    {
      title: '调出库房',
      align: 'center',
      width: Dimen.Name,
      dataIndex: 'supplierName',
      key: 'supplierName',
      render: (_, t) => {
        return t.supplierName ? t.supplierName : t.acceptStorehouseName
      },
    },
    {
      title: '业务部门',
      align: 'center',
      width: Dimen.Department,
      dataIndex: 'departmentName',
      key: 'departmentName',
    },
    {
      title: '业务人员',
      align: 'center',
      width: Dimen.Name,
      dataIndex: 'userName',
      key: 'userName',
    },
    {
      title: '创建时间',
      align: 'center',
      width: Dimen.Time,
      dataIndex: 'createTime',
      key: 'createTime',
      render: (createTime) => {
        return createTime ? moment(createTime).format(DateTimeFormatSimple) : ''
      },
    },
    {
      title: '登账时间',
      align: 'center',
      width: Dimen.Time,
      render: (_, t) => {
        switch (t.storehouseTag) {
          case 1:
            return moment(t.upAccountTime).format(DateTimeFormatSimple)
          default:
            return ''
        }
      },
    },
    {
      title: '总金额（进价）',
      align: 'right',
      width: Dimen.Price,
      dataIndex: 'totalUnitPrice',
      key: 'totalUnitPrice',
      render: (totalUnitPrice) => {
        return totalUnitPrice > -1 ? parseFloat(totalUnitPrice).toFixed(2) : 0
      },
    },
    {
      title: '总金额（售价）',
      align: 'right',
      width: Dimen.Price,
      dataIndex: 'totalRetailPrice',
      key: 'totalRetailPrice',
      render: (totalRetailPrice) => {
        return totalRetailPrice > -1
          ? parseFloat(totalRetailPrice).toFixed(2)
          : 0
      },
    },
  ]
}

export const OneClickWarehousingColumns = (
  startIndex: number,
  billCodeDetail: (r: any) => void
): TableColumnType<any>[] => {
  return [
    {
      title: '上传单据时间',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      dataIndex: 'billTime',
      key: 'storehouseName',
      render: (_, r) => {
        return r?.billTime ? moment(r?.billTime).format(DateTimeFormatSimpleOnly) : ''
      },
    },
    {
      title: '发货单号',
      align: 'left',
      width: '12rem',
      ellipsis: true,
      dataIndex: 'billCode',
      key: 'billCode',
      render: function Element(_, r) {
        return (
          <Button
            type='link'
            size='small'
            style={r?.isImported ? { color: '#999999' } : {}}
            onClick={() => {
              billCodeDetail && billCodeDetail(r)
            }}
          >
            {r?.billCode ? r?.billCode : '-'}
          </Button>
        )
      },
    },
    {
      title: '供应商',
      align: 'center',
      width: '15rem',
      ellipsis: true,
      dataIndex: 'fromEntName',
      key: 'fromEntName',
      render: (_, t) => {
        return t.fromEntName ? t.fromEntName : '-'
      },
    },
    {
      title: '药品',
      align: 'left',
      width: '18rem',
      ellipsis: true,
      dataIndex: 'physicName',
      key: 'physicName',
      render: (_, t) => {
        return t?.list?.length
          ? Array.from(new Set(t.list.map((v: any) => v.physicName)))?.slice(0, 2)
            .join('、') +
          (t.list.length > 2 ? `等${t.list.length}个` : '')
          : '-'
      },
    },
    {
      title: '数量',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      dataIndex: 'codeCount',
      key: 'codeCount',
      render: (_, t) => {
        return t?.codeCount ? t?.codeCount : '-'
      },
    },
    {
      title: '追溯码',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      dataIndex: 'codeCount',
      key: 'codeCount',
      render: (_, t) => {
        return t?.codeCount ? t?.codeCount + '个' : '-'
      },
    },
  ]
}

export const PurchaseDetailsInformationcolumns = (
  onclick: (text: string, t: any, tt?: string) => void,
  deleteRow: (text: string, t: any,) => void,
): EditableColumnType<any>[] => {
  return [
    {
      title: '药品编码',
      align: 'center',
      width: '7rem',
      fixed: 'left',
      ellipsis: true,
      dataIndex: 'no',
      key: 'no',
      render: function Element(_, record: any) {
        return (
          <div
            style={{
              color: !record?.matchedFlag ? "#FA8714" : "#333333",
            }}>
            {!record?.matchedFlag ? '未匹配' : record?.no}
          </div>
        );
      },
    },
    {
      title: '药品名称',
      align: 'left',
      inputType: 'material',
      dataIndex: 'localProdName',
      width: '20rem',
      ellipsis: true,
      key: 'name',
      fixed: 'left',
      placeholder: ' 药品名称',
      // storehouseCategory: storehouseCategory,
      editable: true,
      msfxFlag: true,
      isShowAddcatalog: true,
      autoFocus: (r) => !r.id && !r.localProdName,
      completionType: ItemCompletionType.Material,
      onSelectMaterial: (prev, newdata: any) => {
        const tenantMaterialsCatalogId = newdata.id
        const unitPrice = newdata?.backFillStockPrice > 0 ? newdata.backFillStockPrice : 0
        const retailPrice = newdata?.backFillRetailPrice > 0 ? newdata.backFillRetailPrice : 0
        const splitPrice = newdata?.backFillSplitPrice > 0 ? newdata.backFillSplitPrice : 0
        const next = {
          ...newdata,
          unitPrice,
          retailPrice,
          splitPrice,
          tenantMaterialsCatalogId,
          id: undefined,
        }
        onclick('edit', { prev, next }, 'selectChange')
      },
      render: function Element(_, record: any) {
        return (
          !record?.matchedFlag ?
            <div
              style={{
                height: '55px',
                overflow: ' hidden',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <p
                style={{
                  height: "28px",
                  lineHeight: record?.matchedFlag ? '36px' : "28px",
                  padding: "0",
                  margin: "0",
                  fontWeight: "bolder",
                  color: "#FA8714",
                }}
              >
                {record.localProdName}
              </p>
            </div> :
            <Popover
              content={
                <>
                  <div style={{ width: '500px' }}>
                    <p
                      style={{
                        height: "28px",
                        lineHeight: "36px",
                        padding: "0",
                        margin: "0",
                        fontSize: "16px",
                        fontWeight: "bolder",
                        color: "#333333",
                      }}
                    >
                      {record.localProdName}
                    </p>
                    <p
                      style={{
                        height: "28px",
                        lineHeight: "24px",
                        padding: "0",
                        margin: "0",
                        color: "#999999",
                        fontSize: "14px",
                      }}
                    >
                      {record?.localDisplaySpec}
                    </p>
                  </div>
                </>
              }
            >
              <div
                style={{
                  height: '55px',
                  overflow: ' hidden',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                }}
              >
                <p
                  style={{
                    height: "28px",
                    lineHeight: record?.matchedFlag ? '36px' : "28px",
                    padding: "0",
                    margin: "0",
                    fontWeight: "bolder",
                    color: "#333333",
                  }}
                >
                  {record.localProdName}
                </p>
                <p
                  style={{
                    height: "28px",
                    lineHeight: "28px",
                    padding: "0",
                    margin: "0",
                    color: "#999999",
                    fontSize: "14px",
                  }}
                >
                  {record?.localDisplaySpec}
                </p>
              </div>
            </Popover>
        )
      }
    },
    // {
    //   title: '采购商品信息',
    //   align: 'left',
    //   width: '16rem',
    //   ellipsis: true,
    //   dataIndex: 'approvalNumber',
    //   key: 'approvalNumber',
    //   render: function Element(_: any, record) {
    //     return (
    //       <Popover
    //         content={
    //           <>
    //            <div style={{ width: '500px' }}>
    //               <p
    //                 style={{
    //                   height: '28px',
    //                   lineHeight: '36px',
    //                   padding: '0',
    //                   margin: '0',
    //                   fontSize: '16px',
    //                   fontWeight: 'bolder',
    //                 }}
    //               >
    //                 {record.name}
    //               </p>
    //               <p
    //                 style={{
    //                   height: '28px',
    //                   lineHeight: '24px',
    //                   padding: '0',
    //                   margin: '0',
    //                   color: '#999999',
    //                   fontSize: '14px',
    //                 }}
    //               >
    //                 {record?.displaySpec}
    //               </p>
    //             </div>
    //           </>
    //         }
    //       >
    //         <div
    //           style={{
    //             height: '55px',
    //             overflow: ' hidden',
    //           }}
    //         >
    //           <p
    //             style={{
    //               height: '28px',
    //               lineHeight: '36px',
    //               padding: '0',
    //               margin: '0',
    //               fontSize: '16px',
    //               fontWeight: 'bolder',
    //             }}
    //           >
    //             {record.name}
    //           </p>
    //           <p
    //             style={{
    //               height: '28px',
    //               lineHeight: '24px',
    //               padding: '0',
    //               margin: '0',
    //               color: '#999999',
    //               fontSize: '14px',
    //             }}
    //           >
    //             {record?.displaySpec}
    //           </p>
    //         </div>
    //       </Popover>
    //     )
    //   },
    // },
    // {
    //   title: '国药准字',
    //   align: 'center',
    //   width: '10rem',
    //   ellipsis: true,
    //   dataIndex: 'approvalNumber',
    //   key: 'approvalNumber',
    //   render: (_, t) => {
    //     return t.approvalNumber ? t.approvalNumber : '-'
    //   },
    // },
    {
      title: '售价',
      align: 'center',
      width: '7.5rem',
      editable: true,
      ellipsis: true,
      dataIndex: 'retailPrice',
      key: 'retailPrice',
      rules: [
        {
          pattern: new RegExp(/^(([1-9]\d*)|(0{1}))(\.\d{0,5})?$/),
          message: '请输入正确的格式，最多保留小数点后5位',
        },
      ],
      render: (_, t) => {
        return Number(t.retailPrice) > 0 ? Number(t.retailPrice)?.toFixed(5) : ''
      },
      onSave: (prev, next) => {
        onclick('edit', { prev, next }, 'retailPriceChange')
      },
    },
    {
      title: '单位',
      align: 'center',
      width: '5rem',
      ellipsis: true,
      dataIndex: 'accountUnit',
      key: 'accountUnit',
      render: (_, t) => {
        return t.accountUnit ? t.accountUnit : '-'
      },
    },
    {
      title: '数量',
      align: 'center',
      width: '5rem',
      ellipsis: true,
      dataIndex: 'count',
      key: 'count',
      render: (_, t) => {
        return t.count > 0 ? t.count : '-'
      },
    },
    {
      title: '进价',
      align: 'center',
      width: '7.5rem',
      ellipsis: true,
      editable: true,
      dataIndex: 'unitPrice',
      key: 'unitPrice',
      rules: [
        {
          pattern: new RegExp(/^(([1-9]\d*)|(0{1}))(\.\d{0,5})?$/),
          message: '请输入正确的格式，最多保留小数点后5位',
        },
      ],
      render: (_, t) => {
        return Number(t.unitPrice) > 0 ? Number(t.unitPrice)?.toFixed(5) : ''
      },
      onSave: (prev, next) => {
        onclick('edit', { prev, next }, 'unitPriceChange')
      },
    },
    {
      title: '进货金额',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      dataIndex: 'totalPrice',
      key: 'totalPrice',
      render: (_, t) => {
        return t.totalPrice ? t.totalPrice?.toFixed(2) : ''
      },
    },
    {
      title: '批号',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      // editable: true,
      dataIndex: 'batchNo',
      render: (_, t) => {
        return t.batchNo ? t.batchNo : ''
      },
      onSave: (prev, next) => {
        onclick('edit', { prev, next }, 'batchNoChange')
      },
    },
    {
      title: '生产日期',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      dataIndex: 'productDate',
      key: 'productDate',
      render: (_, t) => {
        return t.productDate ? moment(t.productDate).format(DateTimeFormatSimpleOnly) : '-'
      },
    },
    {
      title: '有效期',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      dataIndex: 'deadline',
      key: 'deadline',
      render: (_, t) => {
        return t.deadline ? moment(t.deadline).format(DateTimeFormatSimpleOnly) : '-'
      },
    },
    {
      title: '追溯码',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      dataIndex: 'traceableCodeList',
      key: 'traceableCodeList',
      render: function Element(_, t) {
        return (
          <Popover
            overlayClassName={styles.popoverContent}
            title="追溯码明细"
            placement='topRight'
            trigger="click"
            content={
              <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                {t?.traceableCodeList?.map((v: any, index: any) => {
                  return (
                    <div key={v?.code} style={{ height: '24px', lineHeight: '24px' }}>
                      {v?.codeLevel == 1 ? v?.code : v?.codeLevel == 2 ? v?.code + "（中码）" : v?.codeLevel == 3 ? v?.code + "（大码）" : "-"}
                    </div>
                  )
                })}
              </div>
            }
          >
            <Button type="link">
              {t?.traceableCodeList?.length ? t?.traceableCodeList?.length + '个' : '-'}
            </Button>
          </Popover>
        )
      },
    },
    {
      title: '操作',
      align: 'center',
      width: '4rem',
      ellipsis: true,
      dataIndex: 'action',
      key: 'action',
      render: function Element(_, t) {
        return (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => deleteRow('delete', t)}>
            <CloseOutlined style={{ color: '#CCCCCC', fontSize: '18px' }} />
          </div>
        )
      },
    },
  ]
}

export const BillCodeDetailColumns = (
): TableColumnType<any>[] => {
  return [
    {
      title: '药品名称',
      align: 'left',
      width: '17rem',
      ellipsis: true,
      dataIndex: 'name',
      key: 'name',
      render: function Element(_, record: any) {
        return (
          <>
            <Popover
              content={
                <>
                  <div style={{ width: '500px' }}>
                    <p
                      style={{
                        height: "28px",
                        lineHeight: "36px",
                        padding: "0",
                        margin: "0",
                        color: record?.isImported ? '#999999' : undefined,
                        fontSize: "16px",
                        fontWeight: "bolder",
                      }}
                    >
                      {record.physicName}
                    </p>
                    <p
                      style={{
                        lineHeight: "24px",
                        padding: "0",
                        margin: "0",
                        color: "#999999",
                        fontSize: "14px",
                      }}
                    >
                      {record.prepnSpec} * {record?.codeInfoListDtoList?.[0]?.prepnAmount} {record.preparationsUnit}/{record?.pkgUnitDesc}/{record?.productEntName}
                    </p>
                  </div>
                </>
              }
            >
              <div style={{ height: "55px" }}>
                <p
                  style={{
                    height: "28px",
                    lineHeight: "36px",
                    padding: "0",
                    color: record?.isImported ? '#999999' : undefined,
                    margin: "0",
                    fontSize: "16px",
                    fontWeight: "bolder",
                  }}
                >
                  {record.physicName}
                </p>
                <p
                  style={{
                    height: "28px",
                    lineHeight: "24px",
                    padding: "0",
                    margin: "0",
                    color: "#999999",
                    fontSize: "14px",
                  }}
                >
                  {record.prepnSpec} * {record?.codeInfoListDtoList?.[0]?.prepnAmount} {record.preparationsUnit}/{record?.pkgUnitDesc}/{record?.productEntName}
                </p>
              </div>
            </Popover>
          </>
        );
      },
    },
    {
      title: '数量',
      align: 'center',
      width: '7rem',
      ellipsis: true,
      dataIndex: 'count',
      key: 'count',
      render: function Element(_, t: any) {
        const value =
          t.leastPkgAmount > 0
            ? `${t.leastPkgAmount}${t.pkgUnitDesc}`
            : '-'

        return (<span style={{ color: t.isImported ? '#999999' : undefined }}>{value}</span>)
      },
    },
    {
      title: '国药准字',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      dataIndex: 'approvalNo',
      key: 'approvalNumber',
      render: function Element(_, t: any) {
        const value = t.approvalNo ? t.approvalNo : '-'
        return (<span style={{ color: t.isImported ? '#999999' : undefined }}>{value}</span>)
      },
    },
    {
      title: '生产批号',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      dataIndex: 'produceBatchNo',
      key: 'produceBatchNo',
      render: function Element(_, t: any) {
        const value = t.produceBatchNo ? t.produceBatchNo : '-'
        return (<span style={{ color: t.isImported ? '#999999' : undefined }}>{value}</span>)
      },
    },
    {
      title: '生产日期',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      dataIndex: 'produceDate',
      key: 'produceDate',
      render: function Element(_, t: any) {
        const value = t.produceDate ? moment(t.produceDate).format(DateTimeFormatSimpleOnly) : '-'
        return (<span style={{ color: t.isImported ? '#999999' : undefined }}>{value}</span>)
      },
    },
    {
      title: '有效日期',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      dataIndex: 'validEndDate',
      key: 'validEndDate',
      render: function Element(_, t: any) {
        const value = t.validEndDate ? moment(t.validEndDate).format(DateTimeFormatSimpleOnly) : '-'
        return (<span style={{ color: t.isImported ? '#999999' : undefined }}>{value}</span>)
      },
    },
    {
      title: '追溯码',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      dataIndex: 'codeInfoListDtoList',
      key: 'codeInfoListDtoList',
      render: function Element(_, t) {
        return (
          <Popover
            overlayClassName={styles.popoverContent}
            title="追溯码明细"
            trigger="click"
            content={
              <div style={{ maxHeight: '300px', paddingRight: '10px', overflowY: 'auto' }}>
                {t?.codeInfoListDtoList?.map((v: any, index: any) => {
                  return (
                    <div key={v?.code} style={{ height: '24px', lineHeight: '24px' }}>
                      {v?.codeLevel == 1 ? v?.code : v?.codeLevel == 2 ? v?.code + "（中码）" : v?.codeLevel == 3 ? v?.code + "（大码）" : "-"}
                    </div>
                  )
                })}
              </div>
            }
          >
            <Button type="link">
              {t?.codeInfoListDtoList?.length ? t?.codeInfoListDtoList?.length + '个' : '-'}
            </Button>
          </Popover>
        )
      },
    },
  ]
}
